module.exports = "/images/trail-7.jpg";